import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteTrackingPage = {
  name: "deleteTrackingPage" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
